import { render, staticRenderFns } from "./mycertificate.vue?vue&type=template&id=e64445b0&scoped=true&"
import script from "./mycertificate.vue?vue&type=script&lang=js&"
export * from "./mycertificate.vue?vue&type=script&lang=js&"
import style0 from "./mycertificate.vue?vue&type=style&index=0&id=e64445b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64445b0",
  null
  
)

export default component.exports